import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

const CustomInput = ({ label, placeholder, ...props }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            {label && (
                <Typography variant="body1" sx={{ marginBottom: '8px', color: '#1c0a00' }}>
                    {label}
                </Typography>
            )}
            <TextField
                variant="outlined"
                placeholder={placeholder}
                {...props}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#ccc',
                        },
                        '&:hover fieldset': {
                            borderColor: '#888',
                        },
                        '&.Mui-focused fieldset': {
                            borderImage: 'linear-gradient(135deg, #1c0a00 48%, #ff7dff 151%) 1',
                        },
                    },
                    '& input': {
                        padding: '12px 14px',
                    },
                }}
            />
        </Box>
    );
};

export default CustomInput;
